var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['env-tag', _vm.envClass, ("env-variant-" + _vm.variant)]},[_c('span',{staticClass:"env-dot"}),_vm._v(" "+_vm._s(_vm.displayName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }